import { render } from "./PermissionsModal.vue?vue&type=template&id=9e73e230&ts=true"
import script from "./PermissionsModal.vue?vue&type=script&lang=ts"
export * from "./PermissionsModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__